<app-cities-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [hideLabel]="true"
  [parentFormGroup]="form"
  class="kendo-select-filter"
  [isInModal]="false"
>
</app-cities-select>
